import React, { useEffect } from "react";
import "./inventoryManagement.css";
import payment_img1 from "assets/inventory/payment1.jpg";
import payment_img2 from "assets/inventory/payment2.jpg";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";
import FaqBlock from "Component/FaqBlock/faqBlock";

const PaymentSchedule = () => {
  const questions = [
    "What is a Real Estate Expense Management in CRM?",
    "What are the key benefits of using a Real Estate Expense Management CRM?",
    "How does a Real Estate Expense Management CRM help reduce costs?",
    "What features should I look for in a Real Estate Expense Management CRM?",
  ];
  const answers = [
    "Expense management in real estate CRM involves organizing and tracking costs related to real estate transactions, including creating cost sheets and payment schedules.",
    [
      "Key benefits of using a real estate expense management CRM:",
      "1: Streamlines cost sheet creation and customization.",
      "2: Manages multiple payment schedules and schemes efficiently.",
      "3: Ensures compliance with GST and other taxation laws.",
      "4: Facilitates quick sharing of cost information with clients.",
    ],
    "A real estate expense management CRM reduces costs by automating complex calculations, ensuring accurate financial tracking, and facilitating adherence to tax regulations. Optimizing sales processes and expediting deal closures minimizes administrative overhead and operational expenses effectively.",
    [
      "Features to look for in a real estate expense management CRM:",
      "1: Template-based cost sheet creation.",
      "2: Support for multiple payment schedules and schemes.",
      "3: Integration with GST and other tax compliance features.",
      "4: Ability to customize cost sheets at project and unit levels.",
      "5: User-friendly interface for easy sharing and collaboration",
    ],
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Cost Sheet Payment Schedule | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Cost Sheets & Payment Schedules"
              subTitle="The Realtor Desk simplifies the management of cost sheets and payment schedules, providing clear and detailed breakdowns of property costs and payment plans. This helps both developers and customers stay organized, ensuring transparency and easy tracking of payment milestones throughout the property purchasing process."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Easier Real Estate Expense Management with The Realtor Desk CRM"
                description="Real estate companies often have varied pricing structures, making it crucial to understand the payment schedule during the purchase journey. The Realtor Desk CRM simplifies this by enabling your sales team to quickly create customized cost sheets and payment schedules from pre-configured templates. With just one click, these can be shared directly with leads, streamlining the process and ensuring clarity."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="All Compliance's with GST"
                title="All Compliance's with GST & Other Real Estate Taxation Laws"
                description="Realtor Desk CRM allows you to manage and customize cost sheets at both the project and per unit level, with full support for agreement changes and additional charges outside the agreement. It ensures compliance with GST and other real estate taxation laws, providing a complete solution to manage all financial aspects of your real estate transactions efficiently and transparently."
                image={payment_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Multiple Schemes & Payment Schedules"
                title="Configure Multiple Payment Schemes & Schedules"
                description="The Realtor Desk allows you to configure and manage multiple payment schemes and schedules simultaneously, with pre-approved options integrated into the system. Salespeople can quickly select the right scheme or schedule from a dropdown menu, streamlining the process with just one click, reducing time, and accelerating the sales cycle."
                image={payment_img2}
                imagePosition="left"
            />
            <FaqBlock
                questions={questions}
                answers={answers}
            />
          </div>
      </div>
    </>
  );
};

export default PaymentSchedule;
